import { render, staticRenderFns } from "./LicensesList.vue?vue&type=template&id=542ea426&scoped=true"
import script from "./LicensesList.vue?vue&type=script&lang=js"
export * from "./LicensesList.vue?vue&type=script&lang=js"
import style0 from "./LicensesList.vue?vue&type=style&index=0&id=542ea426&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542ea426",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('542ea426')) {
      api.createRecord('542ea426', component.options)
    } else {
      api.reload('542ea426', component.options)
    }
    module.hot.accept("./LicensesList.vue?vue&type=template&id=542ea426&scoped=true", function () {
      api.rerender('542ea426', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrganisationDetails/Licenses/LicensesList.vue"
export default component.exports